module.exports = __webpack_public_path__ + "static/Hedwig-buyer-pic-10ba32e98ea6909922c2dd14b672f759.svg";